"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _listingModule = require("./listingModule");

var _utils = require("../utils");

var _trackClick = require("../HOCs/trackClick");

var AnalyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));

var _analytics = require("../constants/analytics");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var DisconnectModal = function DisconnectModal(_ref) {
  var isDisconnectModalOpen = _ref.isDisconnectModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      disconnect = _ref.disconnect,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.disconnect);
  };

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "JavaScript is Required to Disconnect");
  }

  var handleDisconnect = function handleDisconnect(buttonType) {
    if (buttonType === _analytics.button.yes) {
      disconnect(listingId, v1ListingId);
    }

    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.disconnect, buttonType],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggleThisModal();
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'BUTTON',
        v2_listing_id: listingId,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isDisconnectModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Disconnect from listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Confirmation"
  }))), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "icon-messaging-warning icon-size-lg"
  })), _react.default.createElement("div", {
    className: "col-xs-11",
    style: {
      paddingTop: '17px'
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "DisconnectAreYouSure"
  }))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: function onClick() {
      return handleDisconnect(_analytics.button.yes);
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Yes"
  })), {
    value: 'DISCONNECT_MODAL_YES'
  }), trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px'
    },
    className: "btn btn-lg btn-default cnqr-muted pull-right",
    onClick: function onClick() {
      return handleDisconnect(_analytics.button.no);
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "No"
  })), {
    value: 'DISCONNECT_MODAL_NO'
  })))));
};

var mapStateToDisconnectProps = function mapStateToDisconnectProps(state) {
  return {
    isDisconnectModalOpen: state.listing.isDisconnectModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID
  };
};

DisconnectModal.propTypes = {
  isDisconnectModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  disconnect: _propTypes.default.func.isRequired,
  toggle: _propTypes.default.func.isRequired,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object,
  trackButtonClick: _propTypes.default.func,
  userId: _propTypes.default.string,
  companyUUID: _propTypes.default.string
};

var _default = (0, _reactRedux.connect)(mapStateToDisconnectProps, {
  toggle: _listingModule.toggleModal,
  disconnect: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(DisconnectModal);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/DisconnectModal.js
// module id = 271
// module chunks = 0